
































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from '@/store/entities/page-request'
import _ from 'lodash';    
import AppConsts from "@/lib/appconst";
import SearchBins from "@/views/operation/location/locking/searchbins.vue"
import SearchTransports from "@/views/operation/location/locking/searchtransports.vue"

 class  PageCreateSessionRequest extends PageRequest{
        uncompletedObjectOnly: boolean=false;
        keyword: string="";
}
class CreateLockingModel{
  name:string;
  locationType:string;
}
@Component({
  components: { 'search-bins':SearchBins,'search-transports': SearchTransports}
})
export default class CreateLocking extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  spinShow:boolean = false;
  locking:CreateLockingModel=new CreateLockingModel();
  note:string="";
  locationTypes =[];
  selectedLocationIds =[];
  isLocationBin: boolean=false;
  async getLocationTypes(){
     await this.$store.dispatch({
            type:'locationLocking/getLocationTypes',
            data:{
              hasAllItem: false
            }
        }).then(re=>{
          this.locationTypes = re.items;
          this.locking.locationType = Util.isNull(this.locationTypes) || this.locationTypes.length<=0?'':this.locationTypes[0].code;
          this.changeLocationType();
        });
  }
  async getTransportTypes(){
    await this.$store.dispatch({
          type:'transport/getTransportTypes',
          data:{
            hasAllItem: true
          }
     });
  }
  async getTransportStatuses(){
      await this.$store.dispatch({
          type:'transport/getTransportStatuses',
          data:{
            hasAllItem: true
          }
      })
  }
  async getBinTypes(){
      await this.$store.dispatch({
          type:'bin/getBinTypes'
      })
  }
  async getRooms(){
        await this.$store.dispatch({
          type:'bin/getRooms'
      })
  }
  async getAisles(){
      await this.$store.dispatch({
          type:'bin/getAisles'
      })
  }
  getIsLocationBin()
  {
    this.isLocationBin= !Util.isNull(this.locking) && !Util.isNull(this.locking.locationType) && this.locking.locationType == AppConsts.locationType.bin;
  }
  onGoBack(){
          this.$root.$router.push({name: 'location-locking'});
  }
  hasItems()
  {
      return !Util.isNull(this.selectedLocationIds) && this.selectedLocationIds.length>0;
  }
  changeLocationType()
  {
    this.getIsLocationBin();
  }
  async save() {
    if(Util.isNull(this.selectedLocationIds) || this.selectedLocationIds.length<=0)
    {
      Util.showNoticeErrorMsg(this,"Error.NoDetail");
      return;
    }
    this.$Modal.confirm({
          title:this.L('Tips'),
          content:this.L('Confirm.CreateLocationLocking'),
          okText:this.L('Yes'),
          cancelText:this.L('No'),
          onOk:async()=>{
            this.spinShow = true;
            try {
               
                var data = {
                    name : this.locking.name,
                    locationType : this.locking.locationType,
                    locationIds : this.selectedLocationIds
                };
                console.log("data", data);
                await this.$store.dispatch({
                  type: "locationLocking/create",
                  data: data
                }) 
                .then(result => {
                  Util.showSuccessMsg(this,"Success.CreateLocationLocking");
                  this.reset();
                  this.$root.$router.push({name: 'view-locking/:id', params: {id: result.id}})
                });
                this.spinShow = false;
            } catch (error) {
                this.spinShow= false;
            }
          }
    });
  }
  reset()
  {
    this.locking = new CreateLockingModel();
    this.selectedLocationIds=[];
  }
  
  async created(){
      this.spinShow= true;
      try {
        this.reset();
        await this.getLocationTypes();
        await this.getTransportTypes();
        await this.getTransportStatuses();
        await this.getRooms();
        await this.getAisles();
        await this.getBinTypes();
        this.spinShow = false;
      } catch (error) {
        this.spinShow = false;
      }
  }
  lockingRule = {
    name: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Name")),
        trigger: "blur"
      }
    ],
    type: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Type")),
        trigger: "blur"
      }
    ]
  };
}
